module.exports = __webpack_public_path__ + "media/chromaticnoise.fc3103d9.mp4";